import { Button, Modal, Paragraph } from '@contentful/f36-components';

const ErrorModal = ({ isShown, errorMessage, onClose }) => (
  <Modal
    onClose={onClose}
    isShown={isShown}
    title="Migration Failed"
    size="fullscreen"
  >
    {() => (
      <>
        <Modal.Content style={{ padding: '0.5rem' }}>
          <Paragraph marginBottom="none" style={{ textAlign: 'center' }} fontColor='red900' fontSize="fontSizeM">
            {errorMessage}
          </Paragraph>
        </Modal.Content>
        <Modal.Controls>
          <Button
            variant="transparent"
            onClick={onClose}
            size="small"
          >
            Dismiss
          </Button>
        </Modal.Controls>
      </>
    )}
  </Modal>
);

export default ErrorModal;
